// pages/index.js

import React from 'react';
import ImageAndTextExample from '../components/Navbar/Home';

const Home = () => {
    return (
        <div
            
        >
            
            <div>
                <ImageAndTextExample />
            </div>
        </div>
    );
};

export default Home;
